module.exports = __webpack_public_path__ + "static/media/banner_webshopper_2020.b09e0a50.b09e0a50.jpg";